import { Controller } from "@hotwired/stimulus"

// Horizontal-scroll shadow for shared/_scrollable_table: while the container is
// scrolled right, sticky-column cells (marked with stickyClassValue) get a
// right-edge shadow so the frozen column reads as floating above the rest.
//
// It also flags the container itself with `data-scrolled` while scrolled, so
// CSS can style sticky cells that arrive later (a Turbo Frame swapping in new
// rows) without waiting for the next scroll event: see `.sticky-scroll-edge`.
export default class extends Controller {
  static values = { stickyClass: String }

  connect() {
    this.scroll()
  }

  scroll() {
    const scrolled = this.element.scrollLeft > 0
    this.element.toggleAttribute("data-scrolled", scrolled)
    if (!this.stickyClassValue) return

    const shadow = scrolled ? "4px 0 8px -4px rgba(0, 0, 0, 0.15)" : ""
    this.element.querySelectorAll(`.${this.stickyClassValue}`).forEach((el) => {
      el.style.boxShadow = shadow
    })
  }
}
